import { FilterOption } from '../components/ui/FilterDropdown/FilterDropdown.types';

// The "User" filter on both the org-wide audit log table and the
// per-AI-system monitoring table lists two distinct kinds of actor together
// (a platform user, identified by id, vs a GitHub username seen on repo
// syncs) - encoding the kind into the option value lets a single flat
// dropdown carry both without a second control, and lets the caller recover
// which query param (`userId` vs `githubUserName`) a selection maps to.
const USER_VALUE_PREFIX = 'user:';
const REPO_VALUE_PREFIX = 'repository:';

export type LogUserOptions = {
  appUsers: { id: string; name: string }[];
  repoUsers: string[];
};

export function buildUserFilterOptions(data: LogUserOptions): FilterOption[] {
  return [
    ...data.appUsers.map((user) => ({
      value: `${USER_VALUE_PREFIX}${user.id}`,
      label: user.name,
    })),
    ...data.repoUsers.map((username) => ({
      value: `${REPO_VALUE_PREFIX}${username}`,
      // The backend already tags repo-sourced usernames with their real
      // provider (e.g. "Ada Lovelace (GitHub)"/"(GitLab)"/"(Bitbucket)") -
      // appending a hardcoded "(GitHub)" here would double up or mislabel
      // non-GitHub repos.
      label: username,
    })),
  ];
}

export function splitUserFilterValues(values: string[]): {
  userIds: string[];
  githubUserNames: string[];
} {
  const userIds: string[] = [];
  const githubUserNames: string[] = [];

  values.forEach((value) => {
    if (value.startsWith(USER_VALUE_PREFIX)) {
      userIds.push(value.slice(USER_VALUE_PREFIX.length));
    } else if (value.startsWith(REPO_VALUE_PREFIX)) {
      githubUserNames.push(value.slice(REPO_VALUE_PREFIX.length));
    }
  });

  return { userIds, githubUserNames };
}
